import { inject } from '@angular/core';
import { Router, type CanActivateFn, type UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import type { AccountInfo } from '@azure/msal-browser';
import { resolveActiveAccount } from './active-account';
import { environment } from '../../../environments/environment';

// The "groups" claim is not part of MSAL's typed TokenClaims, so we extend it.
interface GroupTokenClaims {
	groups?: string[];
}

// Shared check used by both the route guard and the navigation link.
export function userHasQuoteLogAccess(account: AccountInfo | null): boolean {
	if (!account) {
		return false;
	}
	const claims = account.idTokenClaims as GroupTokenClaims | undefined;
	return (
		claims?.groups?.includes(environment.msalConfig.groups.capital) ?? false
	);
}

export function userHasSalesManagerAccess(account: AccountInfo | null): boolean {
	if (!account) return false;

	const claims = account.idTokenClaims as GroupTokenClaims | undefined;
	return claims?.groups?.includes(environment.msalConfig.groups.salesManager) ?? false;
}


// Allows the Quote Log route only for members of the configured security group;
// everyone else is redirected to the E-Filing page.
export const quoteLogGuard: CanActivateFn = (): boolean | UrlTree => {
	const msalService = inject(MsalService);
	const router = inject(Router);

	if (userHasQuoteLogAccess(resolveActiveAccount(msalService))) {
		return true;
	}

	return router.createUrlTree(['/']);
};
